import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { SoporteService } from '@hta/auth';

@Component({
    selector: 'app-impersonation-banner',
    templateUrl: './impersonation-banner.component.html',
    styles: [`
        .impersonation-banner {
            display: flex;
            align-items: center;
            gap: 0.625rem;
            padding: 0.5rem 1rem;
            background: #1e3a5f;
            color: #fff;
            font-size: 0.825rem;
            font-weight: 500;
            position: sticky;
            top: 0;
            z-index: 200;
        }

        .impersonation-banner mat-icon:first-child {
            font-size: 18px;
            width: 18px;
            height: 18px;
            opacity: 0.85;
        }

        .impersonation-banner__text {
            flex: 1;
        }

        .impersonation-banner__timer {
            display: flex;
            align-items: center;
            gap: 3px;
            font-family: monospace;
            font-size: 0.875rem;
            opacity: 0.9;
            padding: 2px 8px;
            border-radius: 4px;
            background: rgba(255,255,255,0.1);
        }

        .impersonation-banner__timer mat-icon {
            font-size: 15px;
            width: 15px;
            height: 15px;
        }

        .impersonation-banner__timer--warning {
            background: rgba(251, 191, 36, 0.25);
            color: #fcd34d;
        }

        .impersonation-banner__timer--danger {
            background: rgba(239, 68, 68, 0.25);
            color: #fca5a5;
            animation: blink 1s step-start infinite;
        }

        @keyframes blink {
            50% { opacity: 0.4; }
        }

        .impersonation-banner__manage {
            color: #fff !important;
            border-color: rgba(255,255,255,0.4) !important;
            font-size: 0.75rem;
            line-height: 1;
            padding: 0 10px;
            height: 28px;
            min-width: unset;
        }

        .impersonation-banner__exit {
            color: rgba(255,255,255,0.75) !important;
            width: 28px;
            height: 28px;
            line-height: 28px;
        }

        .impersonation-banner__exit mat-icon {
            font-size: 18px;
            width: 18px;
            height: 18px;
        }
    `],
    imports: [MatButtonModule, MatIconModule],
})
export class ImpersonationBannerComponent implements OnInit, OnDestroy {
    private readonly soporteService = inject(SoporteService);
    private readonly router = inject(Router);

    visible = false;
    tenantId: number | null = null;
    countdown = 0;
    elapsed = 0;
    private interval: ReturnType<typeof setInterval> | null = null;

    get tiempoTranscurrido(): string {
        const m = Math.floor(this.elapsed / 60).toString().padStart(2, '0');
        const s = (this.elapsed % 60).toString().padStart(2, '0');
        return `${m}:${s}`;
    }

    ngOnInit(): void {
        this.refresh();
        // Refresh every 1 s
        this.interval = setInterval(() => this.tick(), 1000);
    }

    private refresh(): void {
        const info = this.soporteService.getImpersonationInfo();
        if (info) {
            this.visible = true;
            this.tenantId = info.tenantId;
            this.countdown = Math.max(
                0,
                Math.floor((new Date(info.expiracion).getTime() - Date.now()) / 1000)
            );
            const activadoEn = (info as { activadoEn?: string }).activadoEn;
            this.elapsed = activadoEn
                ? Math.floor((Date.now() - new Date(activadoEn).getTime()) / 1000)
                : 0;
        } else {
            this.visible = false;
            this.countdown = 0;
            this.elapsed = 0;
        }
    }

    private tick(): void {
        if (!this.visible) return;
        this.countdown = Math.max(0, this.countdown - 1);
        this.elapsed += 1;
        if (this.countdown <= 0) {
            this.soporteService.stopImpersonation();
            this.visible = false;
        }
    }

    irAPanel(): void {
        this.router.navigate(['/soporte/activar']);
    }

    salir(): void {
        this.soporteService.stopImpersonation();
        this.visible = false;
        this.countdown = 0;
        this.router.navigate(['/soporte/activar']);
    }

    ngOnDestroy(): void {
        if (this.interval !== null) {
            clearInterval(this.interval);
        }
    }
}
